import { boxGrade, boxType, gemEffect, itemType, nftGrade, statisticsNftType } from '../../constants/nft';

const createKeyMap = (data, fileName, sortKey) => {
  const headers = {};
  const keyMap = {};

  // '날짜' 헤더 추가
  headers['날짜'] = '날짜';
  keyMap['날짜'] = data[0].date ? 'date' : 'targetDate';

  for (const [key, value] of Object.entries(data[0])) {
    if (typeof value === 'object') {
      if (key === 'registerNftGradeCounts') {
        const entries = fileName.includes('상자') ? Object.entries(boxGrade) : Object.entries(nftGrade).filter(([grade]) => grade !== '1' && grade !== '101');
        for (const [grade, count] of entries) {
          const headerName = `등록된 NFT 등급 [${count}]`;
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${grade}`;
        }
      } else if (key === 'registerNftTypeCounts') {
        const entries = fileName.includes('상자') ? Object.entries(boxType) : Object.entries(statisticsNftType);
        for (const [grade, count] of entries) {
          const headerName = `등록된 NFT 타입 [${count}]`;
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${grade}`;
        }
      } else if (key === 'transactionNftGradeCounts') {
        const entries = fileName.includes('상자') ? Object.entries(boxGrade) : Object.entries(nftGrade).filter(([grade]) => grade !== '1' && grade !== '101');
        for (const [grade, count] of entries) {
          const headerName = `거래된 NFT 등급 [${count}]`;
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${grade}`;
        }
      } else if (key === 'transactionNftTypeCounts') {
        const entries = fileName.includes('상자') ? Object.entries(boxType) : Object.entries(statisticsNftType);
        for (const [grade, count] of entries) {
          const headerName = `거래된 NFT 타입 [${count}]`;
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${grade}`;
        }
      } else if (key === 'registerItemTypeCounts') {
        for (const [grade, count] of Object.entries(itemType)) {
          const headerName = `등록된 아이템 유형 [${count}]`;
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${grade}`;
        }
      } else if (key === 'transactionItemTypeCounts') {
        for (const [grade, count] of Object.entries(itemType)) {
          const headerName = `거래된 아이템 유형 [${count}]`;
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${grade}`;
        }
      }  else if (key === 'registerGemEffectCounts') {
        for (const [grade, count] of Object.entries(gemEffect)) {
          const headerName = `등록된 보석 유형 [${count}]`;
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${grade}`;
        }
      } else if (key === 'transactionGemEffectCounts') {
        for (const [grade, count] of Object.entries(gemEffect)) {
          const headerName = `거래된 보석 유형 [${count}]`;
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${grade}`;
        }
      } else if (key === 'boxGradeCounts') {
        for (const [grade, count] of Object.entries(boxGrade)) {
          const headerName = `상자 등급 [${count}]`;
          headers[headerName] = headerName;
          const dataKey = Object.keys(value).find((k) => k.toLowerCase() === count.toLowerCase());
          const capitalizedCount = count.charAt(0).toUpperCase() + count.slice(1).toLowerCase();
          keyMap[headerName] = dataKey ? `${key}.${dataKey}` : `${key}.${capitalizedCount}`;
        }
      } else if (key === 'walletToSpendingCounts') {
        for (const [grade, count] of Object.entries(statisticsNftType)) {
          const headerName = `월렛 → 스펜딩 [${count}]`;
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${grade}`;
        }
      } else if (key === 'spendingToWalletCounts') {
        for (const [grade, count] of Object.entries(statisticsNftType)) {
          const headerName = `스펜딩 → 월렛 [${count}]`;
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${grade}`;
        }
      } else if (key === 'breedingCounts') {
        for (const [grade, count] of Object.entries(statisticsNftType)) {
          const headerName = `브리딩 생성 [${count}]`;
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${grade}`;
        }
      } else if (key === 'evolveCounts') {
        for (const [grade, count] of Object.entries(statisticsNftType)) {
          const headerName = `합성 생성 [${count}]`;
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${grade}`;
        }
      } else if (key === 'evolveBurnCounts') {
        for (const [grade, count] of Object.entries(statisticsNftType)) {
          const headerName = `합성 소각 [${count}]`;
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${grade}`;
        }
      } else if (key === 'levelDistributions') {
        for (let level = 0; level <= 40; level += 10) {
          const start = level + 1;
          const end = level + 10;
          const headerName = `레벨 분포 [${start} ~ ${end}]`;
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${level}`;
        }
      } else if (key === 'levelDistribution') {
        const ranges = [
          { start: 0, end: 100, headerName: '합산 레벨 분포 [1- 100]' },
          { start: 100, end: 200, headerName: '합산 레벨 분포 [101- 200]' },
          { start: 200, end: 300, headerName: '합산 레벨 분포 [201- 300]' },
          { start: 300, end: 400, headerName: '합산 레벨 분포 [301- 400]' },
          { start: 400, end: 500, headerName: '합산 레벨 분포 [401- 500]' },
          { start: 500, end: 600, headerName: '합산 레벨 분포 [501- 600]' },
          { start: 600, end: 700, headerName: '합산 레벨 분포 [601- 700]' },
          { start: 700, end: 800, headerName: '합산 레벨 분포 [701- 800]' },
          { start: 800, end: 900, headerName: '합산 레벨 분포 [801- 900]' },
          { start: 900, end: 1000, headerName: '합산 레벨 분포 [901- 1000]' },
          { start: 1000, end: Infinity, headerName: '합산 레벨 분포 [1001 이상]' },
        ];

        for (const { start, end, headerName } of ranges) {
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${start} - ${end}`;
        }
      } else if (key === 'statDistribution') {
        const ranges = [
          { start: 0, end: 1000, headerName: '합산 스탯 분포 [1- 1000]' },
          { start: 1000, end: 2000, headerName: '합산 스탯 분포 [1001- 2000]' },
          { start: 2000, end: 3000, headerName: '합산 스탯 분포 [2001- 3000]' },
          { start: 3000, end: 4000, headerName: '합산 스탯 분포 [3001- 4000]' },
          { start: 4000, end: 5000, headerName: '합산 스탯 분포 [4001- 5000]' },
          { start: 5000, end: 6000, headerName: '합산 스탯 분포 [5001- 6000]' },
          { start: 6000, end: 7000, headerName: '합산 스탯 분포 [6001- 7000]' },
          { start: 7000, end: 8000, headerName: '합산 스탯 분포 [7001- 8000]' },
          { start: 8000, end: 9000, headerName: '합산 스탯 분포 [8001- 9000]' },
          { start: 9000, end: 10000, headerName: '합산 스탯 분포 [9001- 10000]' },
          { start: 10000, end: Infinity, headerName: '합산 스탯 분포 [10001 이상]' },
        ];

        for (const { start, end, headerName } of ranges) {
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${start} - ${end}`;
        }
      } else if (key === 'newItemCounts') {
        const entries = fileName.includes('보석') ? Object.entries(gemEffect) : Object.entries(itemType);
        for (const [grade, count] of entries) {
          const headerName = `생성된 [${count}]`;
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${grade}`;
        }
      } else if (key === 'burnedItemCounts') {
        const entries = fileName.includes('보석') ? Object.entries(gemEffect) : Object.entries(itemType);
        for (const [grade, count] of entries) {
          const headerName = `소각된 [${count}]`;
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${grade}`;
        }
      } else {
        for (const [subKey, subValue] of Object.entries(value)) {
          const headerName = `${key}_${subKey}`;
          headers[headerName] = headerName;
          keyMap[headerName] = `${key}.${subKey}`;
        }
      }
    } else {
      if (key !== 'date' && key !== 'targetDate') {
        let headerName = '';
        // 토큰
        if (key === 'userWalletBalanceXper') headerName = 'XPER 현황';
        else if (key === 'userWalletBalancePer') headerName = 'PER 현황';
        else if (key === 'userWalletBalanceHvh') headerName = 'HVH 현황';
        else if (key === 'xperToUsdt') headerName = 'XPER 시세';
        else if (key === 'perToUsdt') headerName = 'PER 시세';
        else if (key === 'hvhToUsdt') headerName = 'HVH 시세';
        else if (key === 'acquisitionUsageXper') headerName = 'XPER 획득량 - 사용량';
        else if (key === 'createdXper') headerName = 'XPER 획득량 총합';
        else if (key === 'xperAcquisitionComparedToPreviousDay') headerName = 'XPER 획득량 변화 [전날 대비]';
        else if (key === 'consumedXper') headerName = 'XPER 사용량 총합';
        else if (key === 'xperConsumptionComparedToPreviousDay') headerName = 'XPER 사용량 변화 [전날 대비]';
        else if (key === 'acquisitionUsagePer') headerName = 'PER 획득량 - 사용량';
        else if (key === 'createdPer') headerName = 'PER 획득량 총합';
        else if (key === 'perAcquisitionComparedToPreviousDay') headerName = 'PER 획득량 변화 [전날 대비]';
        else if (key === 'consumedPer') headerName = 'PER 사용량 총합';
        else if (key === 'perConsumptionComparedToPreviousDay') headerName = 'PER 사용량 변화 [전날 대비]';
        else if (key === 'acquisitionUsageHvh') headerName = 'HVH 획득량 - 사용량';
        else if (key === 'createdHvh') headerName = 'HVH 획득량 총합';
        else if (key === 'hvhAcquisitionComparedToPreviousDay') headerName = 'HVH 획득량 변화 [전날 대비]';
        else if (key === 'consumedHvh') headerName = 'HVH 사용량 총합';
        else if (key === 'hvhConsumptionComparedToPreviousDay') headerName = 'HVH 사용량 변화 [전날 대비]';
        else if (key === 'spendingCriteriaChangeXper') headerName = 'XPER 스펜딩 기준 변화';
        else if (key === 'withdrawXper') headerName = 'XPER 이동 [스펜딩 → 월렛]';
        else if (key === 'depositXper') headerName = 'XPER 이동 [월렛 → 스펜딩]';
        else if (key === 'spendingCriteriaChangePer') headerName = 'PER 스펜딩 기준 변화';
        else if (key === 'withdrawPer') headerName = 'PER 이동 [스펜딩 → 월렛]';
        else if (key === 'depositPer') headerName = 'PER 이동 [월렛 → 스펜딩]';
        else if (key === 'spendingCriteriaChangeHvh') headerName = 'HVH 스펜딩 기준 변화';
        else if (key === 'withdrawHvh') headerName = 'HVH 이동 [스펜딩 → 월렛]';
        else if (key === 'depositHvh') headerName = 'HVH 이동 [월렛 → 스펜딩]';

        // 마켓 - 차량
        else if (key === 'registerCount') headerName = '등록 수량';
        else if (key === 'transactionCount') headerName = '거래 수량';
        else if (key === 'transactionTotalPrice') headerName = '총 거래 금액';
        else if (key === 'transactionAverageAmount') headerName = '평균 거래 금액';
        else if (key === 'transactionTotalFee') headerName = '총 거래 수수료';
        else if (key === 'registerMaxPrice') headerName = '최고 등록 금액';
        else if (key === 'registerMinPrice') headerName = '최저 등록 금액';
        else if (key === 'registerAverageAmount') headerName = '평균 등록 금액';

        // 마켓 - 차량 상자

        // 마켓 - 아이템

        // 마켓 - 보석

        // NFT - 차량
        else if (key === 'totalIssuedCount') headerName = '총 발행 수';
        else if (key === 'totalSpendingCount') headerName = '총 스펜딩 수';
        else if (key === 'averageHoldingPerHolder') headerName = '홀더 평균 보유 수';
        else if (key === 'walletToSpendingCount') headerName = '월렛 → 스펜딩 수';
        else if (key === 'spendingToWalletCount') headerName = '스펜딩 → 월렛 수';
        else if (key === 'breedingCount') headerName = '브리딩 생성 수';
        else if (key === 'evolveCount') headerName = '합성 생성 수';
        else if (key === 'evolveBurnCount') headerName = '합성 소각 수';

        // NFT - 차량 레벨 합산

        // NFT - 차량 능력치 합산

        // NFT - 차량 상자
        else if (key === 'totalHolderBoxCount') headerName = '총 홀더 상자 수';
        else if (key === 'averageHolderCount') headerName = '홀더 평균 보유 수';
        else if (key === 'regularCount') headerName = '레귤러 수';

        // 아이템 - 아이템
        else if (key === 'totalItemCount') headerName = '총 아이템(보석) 수';
        else if (key === 'newItemCount') headerName = '생성 수';
        else if (key === 'burnedItemCount') headerName = '소각 수';

        // 아이템 - 보석

        // 유저
        else if (key === 'totalAccountCount') headerName = '총 회원 수';
        else if (key === 'suspendedAccountCount') headerName = '이용 정지 회원 수';
        else if (key === 'newAccountCount') headerName = '신규 회원 수';
        else if (key === 'signInAccountCount') headerName = '로그인 회원 수';
        else if (key === 'activatedAccountCount') headerName = '활성 회원 수';
        else if (key === 'totalHolderCount') headerName = '총 홀더 수';
        else if (key === 'suspendedHolderCount') headerName = '이용 정지 홀더 수';
        else if (key === 'signInHolderCount') headerName = '로그인 홀더 수';
        else if (key === 'activatedHolderCount') headerName = '활성 홀더 수';
        else if (key === 'convertedHolderCount') headerName = '홀더 전환 수';
        else if (key === 'convertedNonHolderCount') headerName = '비홀더 전환 수';
        else if (key === 'convertedFirstHolderCount') headerName = '최초 홀더 전환 수';

        // 정의되지 않은 변수는 서버에서 온 변수명 그대로 출력
        else headerName = key;

        headers[headerName] = headerName;
        keyMap[headerName] = key;
      }
    }
  }

  let sortedHeaders;
  let sortedKeyMap;

  if (sortKey) {
    // sortKey에 정의된 헤더 순서대로 정렬
    sortedHeaders = Object.keys(headers).sort((a, b) => {
      const indexA = sortKey.indexOf(a);
      const indexB = sortKey.indexOf(b);
      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });

    sortedKeyMap = {};
    sortedHeaders.forEach((header) => {
      sortedKeyMap[header] = keyMap[header];
    });
  } else {
    // 기존 순서 유지
    sortedHeaders = Object.keys(headers);
    sortedKeyMap = keyMap;
  }

  console.log({
    headers: sortedHeaders,
    keyMap: sortedKeyMap
  });

  return { headers: sortedHeaders, keyMap: sortedKeyMap };
};

export default createKeyMap;
